<template>
<input 
v-show="false"
type="file"
@change="tmpUploadImg"
@click="$event.target.value=''"
ref="imgUpload" 
accept="image/gif, image/jpeg , image/png">


</template>

<script setup>
import { reactive,ref } from 'vue';

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { fileUpload,tempUpload } from '@/api/file';

const emits = defineEmits(['returnFileList','returnData'])

const imgUpload = ref()
const state = reactive({
    tmpImgData : [],
    fileParams : {
        up_path : '',
        fileListVo  : []
    }
})

const clickInput = () => {
    imgUpload.value.click()
}
const tmpUploadImg = async(event)=>{
    try{
        setIsLoading(true)
        let reader = new FileReader() 
        reader.readAsDataURL(event.target.files[0])
        reader.onload = (e) => {
            emits('returnData',e.target.result)
        }

        const form = new FormData()
        form.append('file',event.target.files[0])
        tempUpload(form).then((res)=>{
          if(res.rtn){
            state.tmpImgData = []
            state.tmpImgData.push(res.rtn)
            state.fileParams.fileListVo = []
            state.fileParams.fileListVo.push(res.rtn)
          }
        }).catch((e)=>{
          alert('이미지 임시업로드 오류!')
          console.log('error => ',e)
        })
    }catch(e){
        console.log(e)
    }finally{
        setIsLoading(false)
    }
    


    
    
}


//임시 파일 -> 실제 저장 함수
const uploadFile = async (path) =>{

    let params = state.fileParams

    if(path && path != ''  && path != undefined){
        params.up_path = path
    }else{
        params.up_path = ''
    }
    try {
        setIsLoading(true)
        const res = await fileUpload(params)
        let fileList = []

        if(res?.rtn.length > 0){
            for(let item of res.rtn){
                fileList.push(item)
            }
            state.tmpImgData = []
        }
        emits('returnFileList',fileList)
    } catch (err) {
        alert('이미지 업로드 실패!')
        console.error('upload Error => ', err)
    } finally {
        setIsLoading(false)
    }
}

defineExpose({
  state,
  uploadFile,
  clickInput
})

</script>